<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/shaolin_1920x1200.jpg')] bg-center bg-no-repeat">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white" *ngIf="data">
        <h5 class="md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">
          {{data.title}}
        </h5>
      </h3>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->

<!-- Start -->
<section class="relative pt-32 md:pb-24 pb-16">
  <div class="container">
    <div *ngIf="loading" class="flex justify-center items-center py-10">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
    </div>

    <div *ngIf="error" class="text-center">
      <div class="alert alert-danger">
        {{error}}
      </div>
    </div>

    <div *ngIf="!loading && !error && data">
      <div class="md:flex justify-center">
        <div class="lg:w-3/5">
          <div class="flex mt-5">
            <span class="font-medium"><i class="uil uil-calendar-alt me-2"></i>{{data.createTime | date:'mediumDate'}}</span>
            <span class="ms-3 font-medium"><i class="uil uil-clock me-2"></i>{{data.readTime}} {{ 'ARTICLE.READ_MIN' | translate }}</span>
            <span class="ms-3 font-medium"><i class="uil uil-eye me-2"></i>{{data.views}} {{ 'ARTICLE.VIEWS' | translate }}</span>
          </div>

          <div class="flex items-center mt-5">
            <div class="relative inline-block">
              <img [src]="data.thumbnailImage ? data.thumbnailImage : 'assets/images/items/2.jpg'" class="h-14 rounded-full" alt="">
            </div>

            <div class="ms-3">
              <span class="font-semibold block">{{data.author}}</span>
              <span class="text-slate-400 text-sm block mt-1">{{ `ARTICLES.${data.category}` | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="data.backgroundImage" class="md:flex justify-center mt-6">
        <div class="lg:w-full">
          <div class="relative">
            <img [src]="data.backgroundImage" class="rounded-lg shadow-md dark:shadow-gray-800" alt="">
          </div>
        </div>
      </div>

      <div class="md:flex justify-center mt-6">
        <div class="lg:w-3/5">
          <div class="article-content" [innerHTML]="safeContent"></div>
        </div>
      </div>
    </div>
  </div><!--end container-->
</section><!--end section-->
<!-- End -->
